import { BaseResponses } from '../base-responses';
export var WebSpotlightResponses;
(function (WebSpotlightResponses) {
    class WebSpotlightStatusResponse extends BaseResponses.BaseContentManagementResponse {
        constructor(debug, rawData, data) {
            super(debug, rawData, data);
        }
    }
    WebSpotlightResponses.WebSpotlightStatusResponse = WebSpotlightStatusResponse;
})(WebSpotlightResponses || (WebSpotlightResponses = {}));
//# sourceMappingURL=web-spotlight-responses.js.map